var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4247 21.8849L12.811 22.0598C16.3947 23.6829 20.698 22.3506 22.707 18.8722C24.8464 15.1681 23.5768 10.4317 19.8713 8.29311C16.1658 6.15454 11.4276 7.42367 9.28825 11.1278C8.05822 13.2575 7.95326 15.7264 8.79549 17.8549L8.95155 18.2492L8.95353 18.6733C8.95585 19.167 8.89073 19.6638 8.71383 20.1674C8.41937 21.0056 7.87723 21.6443 7.48592 22.1041C7.45196 22.144 7.41763 22.1841 7.3829 22.2246C7.79551 22.1875 8.20375 22.1323 8.63709 22.073L8.68848 22.066C9.60048 21.9412 10.6915 21.7919 12.0013 21.8622L12.4247 21.8849ZM4.6302 24.401C4.31726 24.3573 3.81952 23.1613 4.06652 22.7106C4.65907 21.9331 5.14158 21.3728 5.52391 20.9288C6.07964 20.2834 6.42373 19.8838 6.58646 19.4206C6.66378 19.2005 6.70016 18.966 6.69884 18.6839C5.61433 15.9432 5.74689 12.7515 7.33561 10.0008C10.0976 5.21871 16.2147 3.58023 20.9986 6.34119C25.7825 9.10215 27.4216 15.217 24.6596 19.9992C22.0651 24.4913 16.51 26.2095 11.8805 24.1128C10.7858 24.0541 9.87401 24.1788 8.94267 24.3061C7.70012 24.476 6.42282 24.6507 4.6302 24.401Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagingIcon);
export default __webpack_public_path__ + "static/media/messaging-icon.5eed5d2921b469d8c4aea4d343ad3414.svg";
export { ForwardRef as ReactComponent };